/* eslint-disable @typescript-eslint/no-unused-vars */
/**

  ___                       _      ___       _        
 |   \ _  _ _ _  __ _ _ __ (_)__  |   \ __ _| |_ __ _ 
 | |) | || | ' \/ _` | '  \| / _| | |) / _` |  _/ _` |
 |___/ \_, |_||_\__,_|_|_|_|_\__| |___/\__,_|\__\__,_|
       |__/
       
*/

import { VisionApplication } from '../application';
import { TimeSelect } from '../components/timeselect';

export class VisionMap {
    map!: google.maps.Map;
    elementName: string;
    activeMarkerData: string;

    private contextMenuDiv!: HTMLDivElement;

    constructor(elementName: string) {
        this.activeMarkerData = '';

        this.elementName = elementName;

        this.contextMenuDiv = document.createElement('div');
        this.contextMenuDiv.id = 'markerContextMenu';

        this.contextMenuDiv.style.position = 'absolute';
        this.contextMenuDiv.style.backgroundColor = 'white';
        this.contextMenuDiv.style.border = '1px solid #ccc';
        this.contextMenuDiv.style.padding = '8px';
        this.contextMenuDiv.style.boxShadow = '0 2px 6px rgba(0,0,0,0.3)';
        this.contextMenuDiv.style.zIndex = '10000';
        this.contextMenuDiv.style.display = 'none';

        const trackBtn = document.createElement('div');
        trackBtn.className = 'context-menu-item';
        trackBtn.textContent = 'Track';
        trackBtn.style.cursor = 'pointer';
        trackBtn.addEventListener('click', () => this.onTrackClick());

        const editBtn = document.createElement('div');
        editBtn.textContent = 'Edit';
        editBtn.className = 'context-menu-item';
        editBtn.style.cursor = 'pointer';
        editBtn.addEventListener('click', () => this.onEditClick());

        this.contextMenuDiv.appendChild(trackBtn);
        this.contextMenuDiv.appendChild(editBtn);
        document.body.appendChild(this.contextMenuDiv);
        this.contextMenuDiv.oncontextmenu = function (event) {
            return false;
        };
    }

    private onTrackClick() {
        console.log('On Edit Click' + this.activeMarkerData);

        const track = VisionApplication.getInstance().layout.avl2Tab.getTrackingWindow();
        track.show();
        track.setTime(TimeSelect.TODAY);
        track.addAsset(this.activeMarkerData);

        this.hideContextMenu();
    }

    private onEditClick() {
        VisionApplication.getInstance().layout.avl2Tab.assetTree.editAsset(this.activeMarkerData);
        this.hideContextMenu();
    }

    public showContextMenu(x: number, y: number): void {
        this.contextMenuDiv.style.left = `${x}px`;
        this.contextMenuDiv.style.top = `${y}px`;
        this.contextMenuDiv.style.display = 'block';
    }

    async init(mapId: string, lat: number, lng: number) {
        const { Map } = (await google.maps.importLibrary('maps')) as google.maps.MapsLibrary;
        const { AdvancedMarkerElement } = (await google.maps.importLibrary('marker')) as google.maps.MarkerLibrary;
        const { DrawingManager } = (await google.maps.importLibrary('drawing')) as google.maps.DrawingLibrary;
        const { HeatmapLayer } = (await google.maps.importLibrary('visualization')) as google.maps.VisualizationLibrary;

        const center: google.maps.LatLngLiteral = { lat: lat, lng: lng };
        this.map = new google.maps.Map(document.getElementById(this.elementName) as HTMLElement, {
            center,
            zoom: 8,
            //mapId: 'c8fa190976a93e7b'
            mapId: mapId,
        });

        this.map.addListener('click', () => {
            this.hideContextMenu();
        });
    }

    private hideContextMenu(): void {
        this.contextMenuDiv.style.display = 'none';
        this.activeMarkerData = '';
    }

    resize() {
        google.maps.event.trigger(this.map, 'resize');
    }
}
